/**
 * @description Примесь пошаговой инструкции.
 * @type {Vue}
 */
export default {
  data() {
    return {
      /**
       * @description Шаги инструкции.
       * @type {string[]}
       */
      instructionSteps: this.initialAvailableSteps,
    };
  },
  methods: {
    /**
     * @description Получить шаги инструкции.
     * @returns {void}
     */
    fetchInstructionSteps() {
      const onResponse = (steps) => { this.instructionSteps = steps; };
      this
        .$settingGateway
        .viewInstructionSteps()
        .then((result) => result.forEach(onResponse));
    },
  },
  props: {
    /**
     * @description Доступные шаги.
     */
    initialAvailableSteps: { default: () => [], type: Array },
  },
};
